import React from 'react'
import Button from '../../../../_library/Button'
import { Form, Formik } from 'formik'
import { showAxiosError, showSuccessMessage } from '../../../../utils/messenger'
import Field from '../../../../_library/Field'
import { setSeatsIoData } from '../../../../../_common/core/http_services/seatsio'

export const SeatsIoMapManager = ({ eventId, fetchSeatData, setShowModalAttachEvent }) => (
  <div>
    <Formik
      initialValues={{
        chartKey: '',
        chartName: '',
      }}
      validate={values => {
        const errors = {}
        if (!values.chartKey) {
          errors.chartKey = 'Required'
        }
        if (!values.chartName) {
          errors.chartName = 'Required'
        }
        return errors
      }}
      onSubmit={async values => {
        try {
          await setSeatsIoData({
            eventId,
            chartKey: values.chartKey,
            chartName: values.chartName,
          })
          setShowModalAttachEvent(false)
          showSuccessMessage('Event linked successfully!')
          await fetchSeatData(eventId)
        } catch (e) {
          showAxiosError(e?.message)
        }
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
        <Form>
          <div className="col-xs-6 col-12">
            <Field
              id="chartKey"
              label="Chart Key"
              value={values.chartKey}
              error={errors.chartKey}
              touched={touched.chartKey}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="col-xs-6 col-12">
            <Field
              id="chartName"
              label="Chart Name"
              value={values.chartName}
              error={errors.chartName}
              touched={touched.chartName}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          <Button className="btn btn-primary btn-shadow" type="submit" loading={isSubmitting}>
            <span>Set Event</span>
          </Button>
          <div className="div-spacing-20" />
        </Form>
      )}
    </Formik>
  </div>
)
